import { Checkbox, Stack, Typography } from "@mui/material";
import { useGridApiContext } from "@mui/x-data-grid-premium";
import { useCallback } from "react";
import type { AccessPermission } from "@entrilia/shared/api/types";
import AuthorizedBox from "@entrilia/shared/components/AuthorizedBox";
import ExpandCollapseAllButton from "@entrilia/shared/components/ExpandCollapseAllButton";
import { setAllNonGroupRowsSelection } from "@entrilia/shared/utilities/dataGridApiHelper";

interface Props {
  headerName: string | undefined;
  permissions: AccessPermission[];
  hideExpandCollapse?: boolean;
  onExpandToggle?: (expanded: boolean) => void;
}

const GroupHeaderWithSelection = ({ permissions, headerName, hideExpandCollapse, onExpandToggle }: Props) => {
  const apiRef = useGridApiContext();

  const changeSelection = useCallback(
    (newState: boolean) => {
      setAllNonGroupRowsSelection(apiRef, newState);
    },
    [apiRef]
  );

  return (
    <Stack direction="row" sx={{ alignItems: "center" }}>
      <AuthorizedBox permissions={permissions}>
        <Checkbox
          onChange={(_, value) => changeSelection(value)}
          onClick={(evt) => {
            evt.preventDefault();
            evt.stopPropagation();
            changeSelection(true);
          }}
        />
      </AuthorizedBox>
      {!hideExpandCollapse && <ExpandCollapseAllButton onToggle={onExpandToggle} />}
      <Typography variant="caption" color="textSecondary" sx={{ pl: 1 }}>
        {headerName}
      </Typography>
    </Stack>
  );
};

export default GroupHeaderWithSelection;
